import {
  HEART_RATE_SERVICE,
  BATTERY_SERVICE,
  BATTERY_CHARACTERISTIC
} from "../BleContstants";
import { DHeartDevice } from "../model/dHeart/DHeartDevice";
import { Ref, reactive, ref } from "vue";

const batteryPercent = ref<undefined | number>()

export class DHeartBleDevice {
  private static instance: DHeartBleDevice;

  Device: DHeartDevice;
  title: string = "D-Heart";
  data: string = "dHeart";
  battery: number;
  device: BluetoothDevice;
  progress: Ref<string>;

  
  private constructor() { }

  static getInstance() {
    if (this.instance) {
      return this.instance;
    }
    this.instance = new DHeartBleDevice();
    this.instance.progress = ref("");
    return this.instance;
  }

  async setupDevice(): Promise<void> {
    const server = await this.device.gatt.connect();
    const service = await server.getPrimaryService(HEART_RATE_SERVICE);

    const batteryService = await server.getPrimaryService(BATTERY_SERVICE)
    const batteryLevelCharacteristic = await batteryService.getCharacteristic(BATTERY_CHARACTERISTIC)

    // Convert received buffer to number:
    const batteryLevel = await batteryLevelCharacteristic.readValue()

    batteryPercent.value = await batteryLevel.getUint8(0)

    this.battery = batteryPercent.value
  
  }


  handleData(e) {
    const instance = DHeartBleDevice.getInstance();
  }

}
